import {
    getStowAssociateMetrics,
    getAtRiskAislesMetrics, getStowPackageMetrics
} from "../resources/StowResource";
import {publishCount, publishTime} from "../MetricUtility";
import {CYCLE, CYCLE_ID, ERROR_METRIC_SUFFFIX, FALSE, TOTAL} from "../constants";
import {
    AssociateMetric,
    InductPackageMetric,
    Resource,
    AtRiskAislesMetric,
    StowPackageMetric
} from "../enums";
import {getInductPackageMetrics} from "../resources/InductResource";

export const LOAD_METRICS_FOR_OVERVIEW_CALL_BEGIN = "LOAD_METRICS_FOR_OVERVIEW_CALL_BEGIN";
export const LOAD_METRICS_FOR_OVERVIEW_CALL_FAILURE = "LOAD_METRICS_FOR_OVERVIEW_CALL_FAILURE";
export const LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_AISLE = "LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_AISLE";
export const LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_AISLE = "LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_AISLE";
export const LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER = "LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER"
export const LOAD_STOW_MIN_OF_WORK_METRICS_FOR_OVERVIEW_CLUSTER = "LOAD_STOW_MIN_OF_WORK_METRICS_FOR_OVERVIEW_CLUSTER";
export const LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER = "LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER";
export const LOAD_STOW_ASSOCIATE_METRICS_FOR_OVERVIEW_CLUSTER = "LOAD_STOW_ASSOCIATE_METRICS_FOR_OVERVIEW_CLUSTER";
export const LOAD_AT_RISK_AISLES_METRICS_FOR_OVERVIEW = "LOAD_AT_RISK_AISLES_METRICS_FOR_OVERVIEW";
export const FETCH_SMART_STOW_ENABLEMENT_CALL_SUCCESS = "FETCH_SMART_STOW_ENABLEMENT_CALL_SUCCESS";

const metricProcessName = "SCC_STOW_OVERVIEW";

const loadMetricsForOverviewCallBegin = () => ({
    type: LOAD_METRICS_FOR_OVERVIEW_CALL_BEGIN
});
const loadAtRiskAislesMetricsForOverview = (atRiskAislesMetricsMap) => ({
    type: LOAD_AT_RISK_AISLES_METRICS_FOR_OVERVIEW,
    atRiskAislesMetricsMap
});
const loadInductPackageMetricsForOverviewAisle = (inductPackageMetricsMapAisle) => ({
    type: LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_AISLE,
    inductPackageMetricsMapAisle
});
const loadStowPackageMetricsForOverviewAisle = (stowPackageMetricsMapAisle) => ({
    type: LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_AISLE,
    stowPackageMetricsMapAisle
});
const loadInductPackageMetricsForOverviewCluster = (inductPackageMetricsMapCluster) => ({
    type: LOAD_INDUCT_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER,
    inductPackageMetricsMapCluster
});
const loadStowAssociateMetricsForOverviewCluster = (stowAssociateMetricsMapCluster) => ({
    type: LOAD_STOW_ASSOCIATE_METRICS_FOR_OVERVIEW_CLUSTER,
    stowAssociateMetricsMapCluster
});
const loadStowMinOfWorkMetricsForOverviewCluster = (minOfWorkMetricsMapCluster) => ({
    type: LOAD_STOW_MIN_OF_WORK_METRICS_FOR_OVERVIEW_CLUSTER,
    minOfWorkMetricsMapCluster
});
const loadStowPackageMetricsForOverviewCluster = (stowPackageMetricsMapCluster) => ({
    type: LOAD_STOW_PACKAGE_METRICS_FOR_OVERVIEW_CLUSTER,
    stowPackageMetricsMapCluster

});
export const fetchSmartStowEnablementCallSuccess = (isSmartStowEnabled) => ({
    type: FETCH_SMART_STOW_ENABLEMENT_CALL_SUCCESS,
    isSmartStowEnabled
});
const loadMetricsForOverviewCallFailure = () => ({
    type: LOAD_METRICS_FOR_OVERVIEW_CALL_FAILURE
});


export const getAtRiskAislesForOverview = ( nodeId, isDRSStowVisibilityEnabled, cycles,cycleIds, CPTIds, filterIdentifier, isCPTFilterEnabled, isSmartStowEnabled) => {

    const metricName = "getAtRiskAislesMetrics";

    const request = {
        groupBy: Resource.AISLE,
        filters: {
            NODE: [nodeId]
        },
        isAggregationRequired: true
    }

    if (!isDRSStowVisibilityEnabled) {
        request.filters["DRS"] = [FALSE]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length && !isCPTFilterEnabled) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length && !isCPTFilterEnabled) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    if (CPTIds.length && isCPTFilterEnabled) {
        request.filters[[filterIdentifier]] = CPTIds;
    }

    if (isSmartStowEnabled) {
        request.metrics = [
            AtRiskAislesMetric.MINUTES_OF_WORK,
            AtRiskAislesMetric.ADJACENCY_SCORE
        ]
    } else {
        request.metrics = [
            AtRiskAislesMetric.MINUTES_OF_WORK
        ]
    }



    return async (dispatch) => {
        try {
            dispatch(loadMetricsForOverviewCallBegin());
            const startTime = Date.now();
            const atRiskAislesMetricsMap = await getAtRiskAislesMetrics(request);
            if (atRiskAislesMetricsMap) {
                dispatch(loadAtRiskAislesMetricsForOverview(atRiskAislesMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForOverviewCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForOverviewCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getMinOfWorkMetricsForOverviewCluster = (nodeId, isDRSStowVisibilityEnabled, cycles, cycleIds) => {

    const metricName = "getMinOfWorkMetrics";

    const request = {
        groupBy: Resource.CLUSTER,
        filters: {
            NODE: [nodeId]
        },
        metrics: [

            StowPackageMetric.MINUTES_OF_WORK,
            StowPackageMetric.LAST_FIFTEEN_MINUTE_STOW_RATE,
            StowPackageMetric.CURRENT_INDUCTED_COUNT

        ],
        isAggregationRequired: true
    }
    if (!isDRSStowVisibilityEnabled) {
        request.filters["DRS"] = [FALSE]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = cycleIds;
    }


    return async (dispatch) => {
        try {
            dispatch(loadMetricsForOverviewCallBegin());
            const startTime = Date.now();
            const minOfWorkMetricsMapCluster = await getStowPackageMetrics(request);
            if (minOfWorkMetricsMapCluster) {
                removeUnwantedClusters(minOfWorkMetricsMapCluster);
                dispatch(loadStowMinOfWorkMetricsForOverviewCluster(minOfWorkMetricsMapCluster));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForOverviewCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForOverviewCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getStowPackageMetricsForOverviewCluster = (nodeId, isDRSStowVisibilityEnabled, cycles, cycleIds, CPTIds, filterIdentifier, isCPTFilterEnabled) => {

    const metricName = "getStowPackageMetrics";

    const request = {
        groupBy: Resource.CLUSTER,
        filters: {
            NODE: [nodeId]
        },
        metrics: [
            StowPackageMetric.STOW_RATE,
            StowPackageMetric.SCAN_COMPLIANCE,
            StowPackageMetric.PLANNED_COUNT,
            StowPackageMetric.CURRENT_INDUCTED_COUNT
        ],
        isAggregationRequired: true
    }
    if (!isDRSStowVisibilityEnabled) {
        request.filters["DRS"] = [FALSE]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length && !isCPTFilterEnabled) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length && !isCPTFilterEnabled) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    if (CPTIds.length && isCPTFilterEnabled) {
        request.filters[[filterIdentifier]] = CPTIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForOverviewCallBegin());
            const startTime = Date.now();
            const stowPackageMetricsMapCluster = await getStowPackageMetrics(request);
            if (stowPackageMetricsMapCluster) {
                removeUnwantedClusters(stowPackageMetricsMapCluster);
                dispatch(loadStowPackageMetricsForOverviewCluster(stowPackageMetricsMapCluster));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForOverviewCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForOverviewCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}


export const getStowAssociateMetricsForOverviewCluster = (nodeId, cycles, CPTIds, filterIdentifier, isCPTFilterEnabled) => {

    const metricName = "getStowAssociateMetrics";

    const request = {
        groupBy: Resource.CLUSTER,
        filters: {
            NODE: [nodeId]
        },
        metrics: [
            AssociateMetric.ACTIVE_ASSOCIATE_COUNT
        ]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length && !isCPTFilterEnabled) {
        request.filters[CYCLE] = cycles;
    }

    if (CPTIds.length && isCPTFilterEnabled) {
        request.filters[[filterIdentifier]] = CPTIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForOverviewCallBegin());
            const startTime = Date.now();
            const stowAssociateMetricsMapCluster = await getStowAssociateMetrics(request);
            if (stowAssociateMetricsMapCluster) {
                removeUnwantedClusters(stowAssociateMetricsMapCluster);
                dispatch(loadStowAssociateMetricsForOverviewCluster(stowAssociateMetricsMapCluster));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForOverviewCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForOverviewCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getStowPackageMetricsForOverviewAisle = (nodeId, isDRSStowVisibilityEnabled, cycles, cycleIds, CPTIds, filterIdentifier, isCPTFilterEnabled) => {

    const metricName = "getStowPackageMetrics";

    const request = {
        groupBy: Resource.AISLE,
        filters: {
            NODE: [nodeId]
        },
        metrics: [
            StowPackageMetric.PLANNED_COUNT,
            StowPackageMetric.CURRENT_INDUCTED_COUNT]
    }
    if (!isDRSStowVisibilityEnabled) {
        request.filters["DRS"] = [FALSE]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length && !isCPTFilterEnabled) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length && !isCPTFilterEnabled) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    if (CPTIds.length && isCPTFilterEnabled) {
        request.filters[[filterIdentifier]] = CPTIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForOverviewCallBegin());
            const startTime = Date.now();
            const stowPackageMetricsMap = await getStowPackageMetrics(request);
            if (stowPackageMetricsMap) {
                dispatch(loadStowPackageMetricsForOverviewAisle(stowPackageMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForOverviewCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForOverviewCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getInductPackageMetricsForOverviewAisle = (nodeId, cycles, CPTIds, filterIdentifier, isCPTFilterEnabled) => {

    const metricName = "getInductPackageMetrics";

    const request = {
        nodeId: nodeId,
        groupBy: "Aisle",
        metricList: [InductPackageMetric.RECEIVED]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length && !isCPTFilterEnabled) {
        request.filters = {Cycle: cycles}
    }

    if (CPTIds.length && isCPTFilterEnabled) {
        request.filters = {[filterIdentifier]: CPTIds}
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForOverviewCallBegin());
            const startTime = Date.now();
            const inductPackageMetricsMapAisle = await getInductPackageMetrics(request);
            if (inductPackageMetricsMapAisle) {
                dispatch(loadInductPackageMetricsForOverviewAisle(inductPackageMetricsMapAisle));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForOverviewCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForOverviewCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getInductPackageMetricsForOverviewCluster = (nodeId, cycles, CPTIds, filterIdentifier, isCPTFilterEnabled) => {

    const metricName = "getInductPackageMetrics";

    const request = {
        nodeId: nodeId,
        groupBy: "Cluster",
        metricList: [InductPackageMetric.RECEIVED]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length && !isCPTFilterEnabled) {
        request.filters = {Cycle: cycles}
    }

    if (CPTIds.length && isCPTFilterEnabled) {
        request.filters = {[filterIdentifier]: CPTIds}
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForOverviewCallBegin());
            const startTime = Date.now();
            const inductPackageMetricsMapCluster = await getInductPackageMetrics(request);
            if (inductPackageMetricsMapCluster) {
                removeUnwantedClusters(inductPackageMetricsMapCluster);
                dispatch(loadInductPackageMetricsForOverviewCluster(inductPackageMetricsMapCluster));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForOverviewCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForOverviewCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

function removeUnwantedClusters(metricsMap) {
    delete metricsMap[TOTAL];
}



// WEBPACK FOOTER //
// ./src/actions/OverviewActions.js